export default __webpack_public_path__ + "static/media/telephone-icon.6cfddd3e.svg";